import React, { useState, useCallback, useEffect } from 'react'

import UsersList from './users/UsersList'

import { fetchUsers } from './users/service'

const pageSize = 10

const UsersComponent = () => {
  const [users, setUsers] = useState([])
  const [totalUsersCount, setTotalUsersCount] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const fetchUserData = useCallback(async ({ offset = 0 }) => {
    setLoading(true)
    try {
      const response = await fetchUsers({ offset })
      setUsers(response.users)
      setTotalUsersCount(response.total)
      setPageCount(Math.ceil(response.total / pageSize))
    } finally {
      setLoading(false)
    }
  }, [])

  const refreshPage = useCallback(async () => {
    try {
      await fetchUserData({ offset: (currentPage - 1) * pageSize })
    } catch {}
  }, [fetchUserData, currentPage])

  useEffect(() => {
    refreshPage()
  }, [refreshPage, currentPage])

  useEffect(() => {
    fetchUserData({ page: 1 })
  }, [fetchUserData])

  return (
    <React.Fragment>
      <div className='users-page'>
        <div className='users-list'>
          <UsersList
            users={users}
            pageCount={pageCount}
            loading={loading}
            pageSize={pageSize}
            totalItems={totalUsersCount}
            fetchUserData={fetchUserData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            refreshPage={refreshPage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default UsersComponent
